(function () {
    'use strict';

    angular
        .module('app')
        .directive('availableEmail', availableEmailDirective);

    availableEmailDirective.$inject = ['API', '$q',];

    function availableEmailDirective(API, $q) {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            scope: {
                existing: '@'
            },
            link: link,
        };

        return directive;

        function link(scope, element, attrs, ngModel) {
            ngModel.$asyncValidators.unique = function (value) {
                if (ngModel.$isEmpty(value) || !value) {
                    return $q.when();
                }
                if (!angular.isUndefined(attrs.existing)) {
                    if (!scope.existing) {
                        return $q.when();
                    }
                    if (scope.existing && value === scope.existing) {
                        return $q.when();
                    }
                }

                var defer = $q.defer();

                API.Registration.validateEmail({}, { email: value, }).$promise.then(function (response) {
                    if (response.valid && response.available) {
                        defer.resolve();
                    } else {
                        defer.reject(response);
                    }
                });

                return defer.promise;
            };
        }
    }
})();